import { withAITracking } from "@microsoft/applicationinsights-react-js";
import React from "react";
import { Image } from "react-bootstrap";
import Col from "react-bootstrap/esm/Col";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { reactPlugin } from "../../../utilities/AppInsights";
import "./NotFoundPage.css"
import FullLogo from '../../../assets/full_logo.png'
import PrimaryButton from "shared/components/PrimaryButton";

type Props = {
  history: any;
}

class NotFoundPage extends React.Component<Props> {
  render() {
    return (
      <Container className="d-flex align-items-stretch fill-screen">
        <Row className="justify-content-md-center">
          <Col className="align-self-center">
            <Image src={FullLogo} fluid />
          </Col>
          <Col className="align-self-center">
            <h1>404</h1>
            <h2>UH OH!</h2>
            <p> It looks like we're having trouble finding that page.
                Click the button below to go back to the homepage.
            </p>
            <PrimaryButton buttonText={'HOME'} onClick={() => this.props.history.push('/')}></PrimaryButton>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withAITracking(reactPlugin, NotFoundPage);
